import React, { useEffect, useRef } from 'react'
import { createUseStyles } from 'react-jss'
import { getCookie, setCookie } from '../../utils/cookies'

const delay = ms => new Promise(res => setTimeout(res, ms))

const COOKIE_NAME = 'velocityPromo'
const COOKIE_TIMEOUT_EXPIRE_TIME = 'velocityPromoExpireTime'
const COOKIE_TIMEOUT_POPUP_IGNORE = 'velocityPromoPopupIgnore'
const TRIGGER_TIMEOUT = 1000 * 60 // 1 minute

const useStyles = createUseStyles(theme => ({
  buttonPrimary: {
    marginBottom: 20,
    '& button': {
      display: 'inline-block',
      padding: '12px 20px',
      border: 'none',
      color: '#fff',
      backgroundColor: theme.colors.orange,
      border: `1px solid ${theme.colors.orange}`,
      borderRadius: '15px',
      lineHeight: '18px',
      fontSize: '14px',
      fontWeight: 700,
      textDecoration: 'none',
      width: 'auto',
      '&:first-child': {
        marginRight: 20,
      },
      '&:nth-child(2)': {
        marginRight: 0,
        color: theme.colors.orange,
        backgroundColor: '#fff',
      },
      '@media (max-width: 600px)': {
        display: 'block',
        width: '100%',
        marginRight: 0,
        padding: '12px 0',
        '&:first-child': {
          marginRight: 0,
          marginBottom: 10,
        },
      },
      '&:hover': {
        backgroundColor: theme.colors.orangeHover,
        cursor: 'pointer',
      },
      '&:disabled, &[disabled]': {
        backgroundColor: '#cccccc',
        borderColor: '#cccccc',
        color: '#666666',
      },
    },
  },
}))

const CookieTimeOutPopup = () => {
  const classes = useStyles()
  const wrapperRef = useRef(null)
  const [displayPopup, setDisplayPopup] = React.useState(false)
  useOutsideAlerter(wrapperRef)

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          ignorePopupHandler()
        }
      }
      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }, [ref])
  }

  useEffect(() => {
    const popupFn = async () => {
      await delay(10000)
      const promoCookie = getCookie(COOKIE_NAME)
      const popupIgnoreCookie = getCookie(COOKIE_TIMEOUT_POPUP_IGNORE)

      if (promoCookie && !popupIgnoreCookie) {
        const date = new Date()
        const currentTime = date.getTime()
        const cookieTime = parseInt(getCookie(COOKIE_TIMEOUT_EXPIRE_TIME))
        const cookieTimeDifference = cookieTime - currentTime

        if (cookieTimeDifference > TRIGGER_TIMEOUT) {
          setTimeout(() => {
            setDisplayPopup(true)
          }, parseInt(cookieTimeDifference - TRIGGER_TIMEOUT))
        } else if (cookieTimeDifference > 0) {
          setDisplayPopup(true)
        }
      }
    }
    popupFn()
  }, [])

  const ignorePopupHandler = () => {
    setCookie(COOKIE_TIMEOUT_POPUP_IGNORE, 'on', 1)
    setDisplayPopup(false)
  }

  const extendCookieHandler = () => {
    const promoCookie = getCookie(COOKIE_NAME)
    setCookie(COOKIE_NAME, promoCookie, 0.25)
    setDisplayPopup(false)
  }

  if (!displayPopup) {
    return <></>
  }

  return (
    <div
      style={{
        backgroundColor: 'rgba(0,0,0,0.4)',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 99999,
        padding: '15px',
        boxSizing: 'border-box',
      }}
    >
      <div
        ref={wrapperRef}
        style={{
          width: '100%',
          maxWidth: '550px',
          margin: '5vh auto 0',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'end',
            padding: '24px 35px',
            backgroundColor: '#fff',
            borderRadius: '30px 30px 0px 0px',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              fontSize: 12,
              paddingTop: 7,
              color: '#EE2049',
            }}
          >
            <img
              src="/themes/thrifty/assets/images/errorex.png"
              style={{ width: 12, height: 12, marginTop: 2, marginRight: 5 }}
            />
            <span>SESSION EXPIRING</span>
          </div>
          <div style={{ paddingLeft: 10 }}>
            <button
              type="button"
              style={{ border: 'none', backgroundColor: 'transparent', cursor: 'pointer' }}
              onClick={ignorePopupHandler}
            >
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M18.3525 1.38372C17.7667 0.797933 16.8169 0.797933 16.2311 1.38372L9.86719 7.74768L3.50323 1.38372C2.91744 0.797932 1.96769 0.797932 1.38191 1.38372C0.796119 1.96951 0.796119 2.91925 1.38191 3.50504L7.74587 9.869L1.3819 16.233C0.796119 16.8187 0.796118 17.7685 1.3819 18.3543C1.96769 18.9401 2.91744 18.9401 3.50323 18.3543L9.86719 11.9903L16.2311 18.3543C16.8169 18.9401 17.7667 18.9401 18.3525 18.3543C18.9383 17.7685 18.9383 16.8187 18.3525 16.233L11.9885 9.869L18.3525 3.50504C18.9383 2.91925 18.9383 1.96951 18.3525 1.38372Z"
                  fill="#555"
                />
              </svg>
            </button>
          </div>
        </div>
        <div
          style={{
            padding: '0 35px 24px 35px',
            backgroundColor: '#fff',
            borderRadius: ' 0px 0px 30px 30px',
          }}
        >
          <div
            style={{
              fontFamily: 'TTRounds',
              fontStyle: 'normal',
              fontWeight: 'bold',
              fontSize: '35px',
              lineHeight: '1.2',
              color: '#007AC3',
              marginBottom: 20,
            }}
          >
            Your session is about to expire.
          </div>
          <div
            style={{
              fontStyle: 'normal',
              fontWeight: 300,
              fontSize: '16px',
              lineHeight: '22px',
            }}
          >
            <div
              style={{
                marginBottom: 20,
              }}
            >
              Keep your discount active by extending your session.
            </div>
            <div className={classes.buttonPrimary}>
              <button onClick={extendCookieHandler}>Extend for 15 mins</button>
              <button onClick={ignorePopupHandler}>Disregard</button>
            </div>
            <div style={{ fontSize: '12px', lineHeight: '1.2' }}>
              *To access your Virgin Australia Business Flyer discount another time, click the
              Thrifty link from the Virgin Australia Rewards Portal or Business Booking Portal.
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CookieTimeOutPopup
